// src/utils/sizeChartResolver.ts
// Static size chart images served from /public
import { cache, CACHE_KEYS, CACHE_TTL } from './cache';

/**
 * IMPORTANT:
 * These paths map to files inside /public
 * Example:
 * public/sizeChart/ladies/topwear.png
 * → URL: /sizeChart/ladies/topwear.png
 */

const sizeCharts = {
  boys: '/sizeChart/boys/boys-and-girls.png',
  girls: '/sizeChart/girls/boys-and-girls.png',

  ladies: {
    kurtis: '/sizeChart/ladies/topwear.png',
    default: '/sizeChart/ladies/topwear.png',
  },

  men: {
    topwear: '/sizeChart/men/topwear.png',
    bottomwear: '/sizeChart/men/bottomwear.png',
    default: '/sizeChart/men/topwear.png',
  },
};

export const getSizeChartImage = (
  category?: string,
  subCategory?: string
): string | null => {
  console.log('[SizeChart] Category:', category, 'SubCategory:', subCategory);

  if (!category) return null;

  const categoryLower = category.toLowerCase().trim();
  const subCategoryLower = subCategory?.toLowerCase().trim() || '';
  
  // Create cache key for size chart mapping
  const cacheKey = `${categoryLower}:${subCategoryLower}`;
  
  // Check cache first (size charts rarely change, so long TTL)
  const cached = cache.get(
    CACHE_KEYS.SIZE_CHART,
    { cacheKey },
    { ttl: CACHE_TTL.SIZE_CHART }
  );
  
  if (cached) {
    console.log('🟢 Cache HIT: Size chart mapping');
    return cached as string;
  }

  let sizeChartPath: string | null = null;

  // BOYS
  if (categoryLower === 'boys') {
    console.log('[SizeChart] Returning boys chart');
    sizeChartPath = sizeCharts.boys;
  }
  // GIRLS
  else if (categoryLower === 'girls') {
    console.log('[SizeChart] Returning girls chart');
    sizeChartPath = sizeCharts.girls;
  }

  // LADIES
  else if (categoryLower === 'ladies') {
    if (subCategoryLower === 'kurtis') {
      console.log('[SizeChart] Returning ladies kurtis chart');
      sizeChartPath = sizeCharts.ladies.kurtis;
    } else {
      console.log('[SizeChart] Returning default ladies chart');
      sizeChartPath = sizeCharts.ladies.default;
    }
  }
  // MEN
  else if (categoryLower === 'men') {
    if (
      ['pants', 'jeans', 'shorts', 'trousers', 'bottomwear'].includes(
        subCategoryLower
      )
    ) {
      console.log('[SizeChart] Returning men bottomwear chart');
      sizeChartPath = sizeCharts.men.bottomwear;
    } else {
      console.log('[SizeChart] Returning men topwear chart');
      sizeChartPath = sizeCharts.men.topwear;
    }
  }

  // Cache the result for future use
  if (sizeChartPath) {
    console.log('🔴 Cache MISS: Storing size chart mapping');
    cache.set(
      CACHE_KEYS.SIZE_CHART,
      sizeChartPath,
      { cacheKey },
      { ttl: CACHE_TTL.SIZE_CHART }
    );
  }

  console.log('[SizeChart] Final result:', sizeChartPath);
  return sizeChartPath;
};
